module.exports = __webpack_public_path__ + "static/media/loudspeaker.0ab7702d.svg";